import { render, staticRenderFns } from "./Partnerships.vue?vue&type=template&id=03b22c94&scoped=true"
import script from "./Partnerships.vue?vue&type=script&setup=true&lang=js"
export * from "./Partnerships.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b22c94",
  null
  
)

export default component.exports